"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductItemValue = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _productItemValueLimit = require("./productItemValues/productItemValueLimit");
var _productItemValueWaitingPeriod = require("./productItemValues/productItemValueWaitingPeriod");
var _labelPropTypes = require("../productTableLabels/defaults/labelPropTypes");
var _dynamicVariantValues = require("./productItemValues/dynamicVariantValues");
var _tickCrossIcons = require("./productItemValues/tickCrossIcons");
var _productItemValueExcess = require("./productItemValues/productItemValueExcess");
var _productItemValueAnnualLimit = require("./productItemValues/productItemValueAnnualLimit");
var _productItemValueLevelOfCover = require("./productItemValues/productItemValueLevelOfCover");
var _tableContext = require("../productsTable/stateHelpers/tableContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable react/forbid-prop-types */

var ProductItemValue = exports.ProductItemValue = function ProductItemValue(_ref) {
  var labelKey = _ref.labelKey,
    formContext = _ref.formContext,
    labelDefinition = _ref.labelDefinition,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    dynamicRelationship = _ref.dynamicRelationship,
    coverDetails = _ref.coverDetails,
    productDefinition = _ref.productDefinition,
    productGroup = _ref.productGroup,
    _ref$onRadioSelect = _ref.onRadioSelect,
    onRadioSelect = _ref$onRadioSelect === void 0 ? function () {} : _ref$onRadioSelect;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    AddOnsMap = _useContext.AddOnsMap,
    AllPlans = _useContext.AllPlans,
    productsAreMerged = _useContext.productsAreMerged,
    selectedOptions = _useContext.selectedOptions,
    selectedProduct = _useContext.tableState.selectedProduct;
  var customValue = labelDefinition.customValue,
    valueType = labelDefinition.valueType,
    valueMap = labelDefinition.valueMap,
    formatters = labelDefinition.formatters,
    dynamicVariant = labelDefinition.dynamicVariant,
    dynamicVariantValue = labelDefinition.dynamicVariantValue;
  var planNumber = productDefinition.planNumber;
  var value = coverDetails[labelKey];
  var HandleRadioSelect = function HandleRadioSelect(value) {
    onRadioSelect({
      productDefinition: productDefinition,
      labelKey: labelKey,
      radioValue: value.radioValue || value
    });
  };
  var handleSelectedOption = function handleSelectedOption(selectedValue, labelKey) {
    onRadioSelect({
      productDefinition: productDefinition,
      labelKey: labelKey,
      radioValue: selectedValue.radioValue || selectedValue
    });
  };
  if (labelKey === 'levelOfCover') {
    return /*#__PURE__*/_react["default"].createElement(_productItemValueLevelOfCover.ProductItemValueLevelOfCover, {
      labelKey: labelKey,
      labelDefinition: labelDefinition,
      disabled: disabled,
      formContext: formContext,
      dynamicRelationship: dynamicRelationship,
      coverDetails: coverDetails,
      productDefinition: productDefinition,
      productGroup: productGroup,
      productsAreMerged: productsAreMerged,
      selectedOptions: selectedOptions,
      onRadioSelect: HandleRadioSelect,
      selectedOptionsHandler: handleSelectedOption,
      AddOnsMap: AddOnsMap,
      AllPlans: AllPlans
    });
  }
  if (labelKey === 'stepDownLevelOfCover') {
    return /*#__PURE__*/_react["default"].createElement(_productItemValueLevelOfCover.ProductItemValueLevelOfCover, {
      labelKey: labelKey,
      labelDefinition: labelDefinition,
      formContext: formContext,
      disabled: disabled,
      coverDetails: coverDetails,
      productDefinition: productDefinition,
      productGroup: productGroup,
      productsAreMerged: productsAreMerged,
      selectedOptions: selectedOptions,
      onRadioSelect: HandleRadioSelect,
      AddOnsMap: AddOnsMap,
      AllPlans: AllPlans
    });
  }
  if (labelKey === 'excess') {
    return /*#__PURE__*/_react["default"].createElement(_productItemValueExcess.ProductItemValueExcess, {
      labelKey: labelKey,
      formContext: formContext,
      labelDefinition: labelDefinition,
      dynamicRelationship: dynamicRelationship,
      disabled: disabled,
      coverDetails: coverDetails,
      productDefinition: productDefinition,
      productGroup: productGroup,
      productsAreMerged: productsAreMerged,
      selectedOptions: selectedOptions,
      onRadioSelect: HandleRadioSelect,
      AddOnsMap: AddOnsMap,
      AllPlans: AllPlans
    });
  }
  if (labelKey === 'annualLimit' && valueType === 'dynamicLimit') {
    return /*#__PURE__*/_react["default"].createElement(_productItemValueAnnualLimit.ProductItemValueAnnualLimit, {
      labelKey: labelKey,
      labelDefinition: labelDefinition,
      formContext: formContext,
      disabled: disabled,
      dynamicRelationship: dynamicRelationship,
      coverDetails: coverDetails,
      productDefinition: productDefinition,
      productGroup: productGroup,
      productsAreMerged: productsAreMerged,
      selectedOptions: selectedOptions,
      onRadioSelect: HandleRadioSelect,
      selectedOptionsHandler: handleSelectedOption,
      AddOnsMap: AddOnsMap,
      AllPlans: AllPlans
    });
  }

  /*
    Used for properties such as routineCare that change across product variants
   */
  if (dynamicVariant && dynamicVariantValue) {
    return /*#__PURE__*/_react["default"].createElement(_dynamicVariantValues.DynamicVariantValues, {
      labelKey: labelKey,
      labelDefinition: labelDefinition,
      disabled: disabled,
      coverDetails: coverDetails,
      productDefinition: productDefinition,
      productGroup: productGroup,
      productsAreMerged: productsAreMerged,
      selectedOptions: selectedOptions,
      onRadioSelect: HandleRadioSelect,
      AddOnsMap: AddOnsMap,
      AllPlans: AllPlans
    });
  }
  if (valueType === 'limit') {
    return /*#__PURE__*/_react["default"].createElement(_productItemValueLimit.ProductItemValueLimit, {
      labelKey: labelKey,
      value: value,
      valueMap: valueMap,
      formatters: formatters,
      productDefinition: productDefinition
    });
  }
  if (valueType === 'custom_waitingPeriods') {
    var waitingPeriodMessages = productDefinition.waitingPeriods.detailed.waitingPeriodMessages;
    if (customValue) {
      return /*#__PURE__*/_react["default"].createElement(_productItemValueWaitingPeriod.ProductItemValueWaitingPeriod, {
        waitingPeriodMessages: customValue,
        planNumber: planNumber,
        selectedProduct: selectedProduct,
        productGroup: productGroup
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_productItemValueWaitingPeriod.ProductItemValueWaitingPeriod, {
      waitingPeriodMessages: waitingPeriodMessages
    });
  }
  if (typeof productDefinition[labelKey] === 'boolean') {
    value = productDefinition[labelKey];
  }

  // This type does not render anything and relies on products table to render
  // valueNote content.
  if (valueType === 'valueNoteOnly') {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_tickCrossIcons.TickCrossIcons, {
    value: value
  });
};
ProductItemValue.propTypes = {
  labelKey: _propTypes["default"].string,
  formContext: _propTypes["default"].any,
  labelDefinition: _propTypes["default"].shape(_labelPropTypes.LabelPropTypes),
  disabled: _propTypes["default"].bool,
  dynamicRelationship: _propTypes["default"].arrayOf(_propTypes["default"].string),
  coverDetails: _propTypes["default"].any,
  productDefinition: _propTypes["default"].any,
  productGroup: _propTypes["default"].string,
  onRadioSelect: _propTypes["default"].func,
  selectedProduct: _propTypes["default"].any
};
var _default = exports["default"] = {
  ProductItemValue: ProductItemValue
};